import { SystemWorkOrderStatus } from '../../../../../entities/job/system.workorder.status';
import { ActivityEntityName } from '../../../../../entities/shared/activity.entity.name';
import { EntitySecurityCapabilityRegistry } from '../../../../entity.security.capability.registry';
import { EntitySecurityFacts } from '../../../../entity.security.facts';
import { JobSecurityRight } from '../../../../modules/job.security.module';
import { jobSecurityHasRight } from '../../job.security.has.right';
import { stageIsFinalised } from '../stage.security.state';
import { StageResourceSecurityCapabilities } from './stage.resource.security.capabilities';
import { StageResourceSecurityEntity } from './stage.resource.security.entity';

EntitySecurityCapabilityRegistry.register<StageResourceSecurityEntity, StageResourceSecurityCapabilities>(ActivityEntityName.WorkOrderResource, getStageResourceSecurityCapabilities);

export function getStageResourceSecurityCapabilities(facts: EntitySecurityFacts<StageResourceSecurityEntity>): StageResourceSecurityCapabilities {

    const entity = facts.before ?? facts.entity ?? facts.after;
    const stage = entity?.stage;
    const role = facts.role;
    const stageAllowsResourceChanges = stageAllowsResourceOperations(stage);

    return {
        canAssign: jobSecurityHasRight(role, JobSecurityRight.Manage) && stageAllowsResourceChanges,
        canUnassign: jobSecurityHasRight(role, JobSecurityRight.Manage) && stageAllowsResourceChanges,
        canDispatch: jobSecurityHasRight(role, JobSecurityRight.Dispatch) && stageAllowsResourceChanges,
        canReissue: jobSecurityHasRight(role, JobSecurityRight.Dispatch) && stageAllowsResourceChanges,
        canUpdateStatus: jobSecurityHasRight(role, JobSecurityRight.ProcessWorkOrder) && stageAllowsResourceChanges,
    };
}

/**
 * Resource operations (assign, unassign, dispatch, reissue, resource status) are locked once the
 * stage is On Hold or Completed and beyond — Completed, Finalised, Closed/Cancelled — matching the
 * manual editor. Finalised stays locked regardless of ModifyJobAfterFinalise: that right unlocks
 * data corrections, not resource changes (WBS-10238).
 */
function stageAllowsResourceOperations(stage: StageResourceSecurityEntity['stage']): boolean {

    const systemStatus = stage?.status?.systemStatus as SystemWorkOrderStatus;

    if (stageIsFinalised(stage)) return false;

    return ![SystemWorkOrderStatus.OnHold, SystemWorkOrderStatus.Completed, SystemWorkOrderStatus.Closed, SystemWorkOrderStatus.Canceled].includes(systemStatus);
}
